import './App.css';
import { Provider, useSelector, useDispatch } from 'react-redux';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import store from './redux/store';
import { useEffect } from 'react';
import { fetchReviews } from './redux/reviewsSlice';
import { fetchGuideContacts } from './redux/guideContactSlice';
import Dashboard from './dsahboard/Dashboard';
import Overview from './pages/overview/Overview';
import ProductDetails from './pages/productDetails/ProductDetails';
import SideBar from './components/SideBar/SideBar';
import GuideList from './pages/guide/GuideList';
import GuideProfile from './pages/guideProfile/GuideProfile';
import ScrollToTop from './utility/ScrollToTop';

function AppContent() {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.reviews.loading);
  const reviews = useSelector((state) => state.reviews.reviews);

  useEffect(() => {
    dispatch(fetchReviews());
    dispatch(fetchGuideContacts());
  }, [dispatch]);

  if (loading || reviews.length === 0) {
    return <div className="loading"><div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div></div>; // Display loading indicator
  }

  return (
    <div className="App">
      <SideBar />
      <div className="content">
        <Routes>
          <Route path="/" element={<Overview />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/products/:productCode" element={<ProductDetails />} />
          <Route path="/guides" exact element={<GuideList />} />
          <Route path="/guides/:guideName" element={<GuideProfile />} />
        </Routes>
      </div>
    </div>
  );
}

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter basename="/">
        <ScrollToTop/>
        <AppContent />
      </BrowserRouter>
    </Provider>
  );
}

export default App;